import {Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'iconify',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './iconify.component.html',
  styleUrls: ['./iconify.component.css'],
  host: { ngSkipHydration: 'true' },
})
export class IconifyComponent {
    @Input() icon = '';
    @Input() classNames = '';
    @Input() size:number | string = 0;

    get style(){
        return `
      ${this.size ? `font-size: ${this.size}px;` : ''}
    `
    }
}
